import usePersistentState from './usePersistentState';

export const ENABLE_EXTERNAL_LOGIN_KEY = 'enableExternalLogin';

const useEnableExternalLogin = () => usePersistentState(ENABLE_EXTERNAL_LOGIN_KEY, false);

export default useEnableExternalLogin;
